import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { trackPwaEvent } from '@/lib/pwa';

const UPDATE_CHECK_INTERVAL_MS = 60 * 60 * 1000;

/**
 * Atualização silenciosa: quando há versão nova, ela é aplicada na próxima
 * troca de página (o usuário já está saindo da tela, então nada digitado se
 * perde). Sem barra ou aviso.
 */
export function UpdatePrompt() {
  const location = useLocation();
  const lastPathRef = useRef(location.pathname);
  const isApplyingRef = useRef(false);
  const {
    needRefresh: [hasNewVersion],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(swUrl, registration) {
      if (!registration) return;
      const checkForUpdate = async () => {
        if (registration.installing || !navigator.onLine) return;
        try {
          // Confere se o sw.js responde antes de atualizar (evita erro com rede instável)
          const response = await fetch(swUrl, { cache: 'no-store', headers: { 'cache-control': 'no-cache' } });
          if (response.status === 200) await registration.update();
        } catch (error) {
          console.warn('[pwa] falha ao verificar nova versão', error);
        }
      };
      setInterval(checkForUpdate, UPDATE_CHECK_INTERVAL_MS);
      // Ao voltar para a aba também confere, para quem deixa o app aberto por dias
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') void checkForUpdate();
      });
    },
    onRegisterError(error) {
      console.error('[pwa] falha ao registrar o service worker', error);
    },
  });

  useEffect(() => {
    const hasChangedPage = location.pathname !== lastPathRef.current;
    lastPathRef.current = location.pathname;
    if (!hasNewVersion || !hasChangedPage || isApplyingRef.current) return;
    isApplyingRef.current = true;
    trackPwaEvent('atualizado');
    // Ativa o service worker novo e recarrega já na página de destino
    void updateServiceWorker(true);
  }, [location.pathname, hasNewVersion, updateServiceWorker]);

  return null;
}
